module.exports = __webpack_public_path__ + "img/dab_lea.0bddded8.jpg";